import Login from "components/_Pages/templates/pages/Login";

export default function LoginPage() {
  return <Login.Aurora />;
}
